<div class="benchmark">
	<p class="label">
		{{ label | titlecase }}
	</p>
	<div class="line-graph">
		<div
			class="rail"
			[matTooltip]="!percentage ? '0%' : null"
			matTooltipPosition="below"
			matTooltipClass="au-benchmark-tooltip"
		></div>
		<div
			[matTooltip]="percentage + '%'"
			matTooltipClass="au-benchmark-tooltip green"
			matTooltipPosition="left"
			[style.left.%]="leftProgress"
			class="left-progress"
		></div>
		@if (!percentage) {
			<div class="zero-line"></div>
		}
		<div
			[matTooltip]="'+' + percentage + '%'"
			matTooltipClass="au-benchmark-tooltip red"
			matTooltipPosition="right"
			[style.right.%]="rightProgress"
			class="right-progress"
		></div>
	</div>
</div>
